import {DetailField} from "../../shared";

export const CONTACTO_DETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'celular', label: 'Teléfono' },
  { name: 'email', label: 'Email' },
  // { name: 'domicilio', label: 'Domicilio' },
  // { name: 'ciudad', label: 'Ciudad' }
];
